import { apiBase } from "../api.config";

export const LoginPlatform = {
  login: data => apiBase.post("/api/user/auth", data),
  confirm: data => apiBase.post("/api/user/auth/confirm", data)
};
export const registerPlatform = {
  register: data => apiBase.post("/api/user/register", data),
  confirm: data => apiBase.post("/api/user/register/confirm", data)
};

export const Data = {
  products: token => apiBase.get("/api/user/product/", token),
  product: (id, token) => apiBase.get(`/api/user/product/${id}`, token),
  brand: token => apiBase.get("/api/user/brand", token),
  model: (brandID, token) =>
    apiBase.get(`/api/user/brand/${brandID}/model`, token),
  type: (brandID, modelID, token) =>
    apiBase.get(`/api/user/brand/${brandID}/model/${modelID}/type`, token),
  tag: token => apiBase.get("/api/user/filter/tag", token),
  vendor: token => apiBase.get("/api/user/filter/vendor", token),
  part_brand: token => apiBase.get("/api/part-brand", token),
  category: () => apiBase.get("/api/category")
};

export const ShoppingCar = {
  add: (data, token) => apiBase.post("/api/user/cart", data, token),
  get: token => apiBase.get("/api/user/cart", token),
  delete: (id, token) => apiBase.delete(`/api/user/cart/${id}`, token),
  update: (id, data, token) => apiBase.put(`/api/user/cart/${id}`, data, token)
};

export const Order = {
  get: token => apiBase.get("/api/user/order", token),
  create: (data, token) => apiBase.post("/api/user/order", data, token)
};

export const Vendor = {
  get: (vendorID, token) =>
    apiBase.get(`/api/user/vendor/${vendorID || ""}`, token)
};

export const User = {
  get: token => apiBase.get("/api/user/account", token),
  update: (data, token) => apiBase.put("/api/user/account", data, token)
};

export const ShoppingNote = {
  get: token => apiBase.get("/api/user/notice", token)
};
export const Notify = {
  get: token => apiBase.get("/api/notify", token),
  read: (uuid, token) => apiBase.put(`/api/notify/${uuid}`, "", token),
  saveToken: (firebaseToken, token) =>
    apiBase.post("/api/notify/save-token", firebaseToken, token)
};
